import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeline'
})
export class TimelinePipe implements PipeTransform {

  transform(min: number): number {
    var hour = min / 60
    if (hour > 23) hour -= 24
    return hour
  }

}
